import styled from 'styled-components';
import { ProductiveHeading07 } from 'components/styles';

export const Box = styled.div`
  background-color: var(--coolest-gray-10);
  padding: var(--spacing-05) var(--spacing-05) var(--spacing-07)
    var(--spacing-05);
`;

export const Title = styled.div`
  ${ProductiveHeading07};
  margin-bottom: var(--layout-02);
`;

export const Waiting = styled.div`
  padding-top: var(--spacing-10);
  padding-bottom: var(--spacing-10);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
